import {
  addCopyButton,
  addLoadAccountDetailsButton,
  checkValueAgainstList,
  getWindowPosition,
  scrollToPosition,
  configureTableColumns,
  rowDetailsClickHandler,
  addLinkDXGWIdButton,
  showErrorFromApiOperation,
  displayError,
  displayErrorPopup,
  displaySuccessPopup,
} from './main';
import { accountIdPattern } from './accounts';
import { baseApiAxios } from './api';
import { addSpinner, addTableSpinner, removeSpinners } from './sidebar';
import DXGWTabs from '../../jsx/components/forms/DXGWTabs';
import { initDataTable, updateTableFooter, exportButtons, resetTableButton, col, selectColumn } from './datatable';

export const dxGwTableColumns = [
  { id: 'select_col' },
  { id: 'dx_gw_id_col', name: 'DX Gateway Id' },
  { id: 'dx_gw_name_col', name: 'DX Gateway Name' },
  { id: 'aws_account_id_col', name: 'Account ID' },
  { id: 'aws_region_col', name: 'Region' },
  { id: 'netbond_cidr_col', name: 'Transfer Network Peering' },
  { id: 'associations_col', name: 'DX Gateway Associations' },
  { id: 'list_associations_col', name: 'List DX Gateway Associations' },
  { id: 'amazon_addresses_col', name: 'VIF amazon addresses' },
  { id: 'customer_addresses_col', name: 'VIF customer addresses' },
  { id: 'attachments_col', name: 'DX Gateway Attachments' },
  { id: 'virtual_interfaces_col', name: 'Virtual Interfaces' },
  { id: 'status_col', name: 'DX Gateway Status' },
  { id: 'status_update_col', name: 'Last Status Update (UTC)' },
  // { id: 'edit_col' },
];
const dxGwDbAttributes = [
  'id',
  'uuid',
  'dx_gw_id',
  'name',
  'aws_account_id',
  'aws_region',
  'netbond_cidr',
  'status',
  'status_update',
  'numbers',
  'dx_associations',
  'dx_virtual_interfaces',
];
const dxGwDropdownColumns = ['aws_region', 'network_type', 'aws_account_id', 'status'];
const dxGwSearchColumns = ['dx_gw_id', 'name', 'netbond_cidr', 'status_update'];
const dxGwSearchColumnsNumbers = ['numbers.dx_associations', 'numbers.dx_attachments', 'numbers.dx_virtual_interfaces'];

export function initDXGWTable(tableId) {
  configureTableColumns(tableId, dxGwTableColumns);
  let permissions = localStorage.permissions ? localStorage.permissions : false;

  initDataTable(
    tableId,
    [
      {
        text: 'Update all DX Gateways',
        action: function () {
          if (checkValueAgainstList('manage_networks', permissions)) {
            triggerAllDxGwUpdate();
          } else {
            displayErrorPopup(null, "You don't have permissions to update Direct Connect Gateways");
          }
        },
        className: 'updateAllDxGw',
        titleAttr: 'Trigger the update of all Direct Connect Gateways in the Shared Services Account',
      },
      ...exportButtons(),
      resetTableButton(),
    ],
    [
      selectColumn(),
      col('dx_gw_id', 'dx_gw_id_col', 'DX Gateway Id', {
        defaultContent: 'unknown',
        createdCell: function (td) {
          addCopyButton(td);
          addLinkDXGWIdButton(td);
        },
      }),
      col('name', 'dx_gw_name_col', 'DX Gateway Name'),
      col('aws_account_id', 'aws_account_id_col', 'Account ID', {
        createdCell: function (td, cellData) {
          addCopyButton(td);
          addLoadAccountDetailsButton(td);
          if (!accountIdPattern.test(cellData)) $(td).addClass('portal-danger');
        },
      }),
      col('aws_region', 'aws_region_col', 'Region', {
        createdCell: function (td, cellData) {
          addCopyButton(td);
          if (!/^[a-z]{2}-[a-z]{1,12}-\d$/.test(cellData)) $(td).addClass('portal-danger');
        },
      }),
      col('netbond_cidr', 'netbond_cidr_col', 'Transfer Network Peering', {
        orderable: false,
        type: 'ip-address',
        createdCell: function (td, cellData) {
          addCopyButton(td);
          if (!/^(\d{1,3}\.){3}\d{1,3}(\/(\d|[1-2]\d|3[0-2]))$/.test(cellData)) $(td).addClass('portal-danger');
        },
      }),
      col('numbers.dx_associations', 'associations_col', 'DX Gateway Associations', {
        createdCell: function (td, cellData) {
          addCopyButton(td);
          if (cellData === 10) $(td).addClass('portal-danger');
          else if (cellData >= 7 && cellData <= 9) $(td).addClass('portal-warning');
        },
      }),
      col('dx_associations', 'list_associations_col', 'List DX Gateway Associations', { visible: false }),
      col('amazon_addresses', 'amazon_addresses_col', 'VIF amazon addresses', { visible: false }),
      col('customer_addresses', 'customer_addresses_col', 'VIF customer addresses', { visible: false }),
      col('numbers.dx_attachments', 'attachments_col', 'DX Gateway Attachments', { visible: false }),
      col('numbers.dx_virtual_interfaces', 'virtual_interfaces_col', 'Virtual Interfaces', { visible: false }),
      col('status', 'status_col', 'DX Gateway Status', {
        defaultContent: 'unknown',
        createdCell: function (td, cellData) {
          addCopyButton(td);
          if (cellData === 'available') $(td).addClass('portal-success');
          else $(td).addClass('portal-danger');
        },
      }),
      col('status_update', 'status_update_col', 'Last Status Update (UTC)'),
    ],
    function (row, data) {
      if (!data.aws_region) {
        $(row).addClass('portal-danger');
      }
    },
    {
      search: {
        regex: false,
      },
      order: [[2, 'asc']],
      initComplete: function () {
        updateDxGwTableFooter(tableId);
      },
      drawCallback: function () {
        $(window).trigger('resize');
        scrollToPosition();
        removeSpinners();
      },
      preDrawCallback: getWindowPosition,
    },
  );

  rowDetailsClickHandler({ tableId: tableId, rowDetailCallback: formatChildRowDX });
  loadDxGwData(tableId);
}

function loadDxGwData(tableId, exclusive_start_key) {
  $(() => addSpinner());
  $(() => addTableSpinner());

  const payload = {
    action: 'list-network-items',
    attributes: dxGwDbAttributes,
    item_type: 'DX_GW',
    exclusive_start_key: exclusive_start_key || undefined,
    table_data: { length: 500 },
  };

  baseApiAxios
    .getNetworkItems(payload)
    .then(result => appendDxGwData(result, tableId))
    .catch(err => displayError(`<strong>Error:</strong> ${err.message}`))
    .finally(() => {
      scrollToPosition();
      removeSpinners();
    });
}

function appendDxGwData(result, tableId) {
  const dt = $('#' + tableId).DataTable();

  const items = result.items;
  if (items) dt.rows.add(items);
  if (items.length === 500) {
    const exclusive_start_key = {
      item_type: 'DX_GW',
      id: items[items.length - 1].id,
      uuid: items[items.length - 1].uuid,
      dx_gw_id: items[items.length - 1].dx_gw_id,
    };
    loadDxGwData(tableId, exclusive_start_key);
  } else {
    // Only draw and rebuild footer on the final batch
    dt.columns.adjust().draw(false);
    updateDxGwTableFooter(tableId);
    $(window).trigger('resize');
  }
}

function updateDxGwTableFooter(tableId) {
  updateTableFooter(tableId, dxGwTableColumns, dxGwDropdownColumns, dxGwSearchColumns, dxGwSearchColumnsNumbers);
}

async function formatChildRowDX(row) {
  const data = row.data();
  try {
    const dxgw_result = await baseApiAxios.getNetworkItem(data.id, data.uuid, 'DX_GW');
    row.child(
      <div class="detailsContainer">
        <DXGWTabs data={dxgw_result} />
      </div>,
    );
    row.child()[0].setAttribute('class', 'rowDetails');
  } catch (err) {
    showErrorFromApiOperation('Fetching Direct Connect Gateway data failed.')(err);
  }
}

function triggerAllDxGwUpdate() {
  const payload = { action: 'trigger-update-all-directconnect-gateways' };
  addSpinner();

  baseApiAxios
    .getNetworkItems(payload)
    .then(result => {
      displaySuccessPopup(result.message);
    })
    .catch(displayErrorPopup)
    .finally(() => removeSpinners());
}
